<template>
  <div>
    <pageContainer
      :formHeaderImage="NavImage"
      formHeaderImageAltText="VasInformation Header Image"
      formHeaderImageClass="mb-4"
      formHeaderImageWidth="85%"
      :isPageHeader="true"
    >
      <vasInformation />
    </pageContainer>

    <GetHelp v-if="false"></GetHelp>
  </div>
</template>

<script>
import GetHelp from "./GetHelp.vue";
import pageContainer from "./supports/page-container/page-container.vue";
import valueInfoNavImage from "../assets/images/icons/RDBheaderimages/Group 289345.png";
import vasInformation from "./supports/pages/vas-information.vue";
export default {
  components: {
    GetHelp,
    pageContainer,
    vasInformation,
  },
  data() {
    return {
      NavImage: valueInfoNavImage,
    };
  },
  methods: {},

  watch: {},
};
</script>
<style scoped></style>
